import { render, staticRenderFns } from "./ModalNotificacao.vue?vue&type=template&id=38641ef4"
import script from "./ModalNotificacao.vue?vue&type=script&lang=js"
export * from "./ModalNotificacao.vue?vue&type=script&lang=js"
import style0 from "./ModalNotificacao.vue?vue&type=style&index=0&id=38641ef4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports